function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.393 3.866L7.98 18h7.187l-1.56 10.134L24.022 14h-7.187l1.56-10.134zm-.404-2.823c.93-1.262 2.929-.431 2.69 1.118L19.166 12h5.845c1.23 0 1.937 1.4 1.207 2.39L14.011 30.957c-.93 1.262-2.929.431-2.69-1.118L12.834 20H6.99c-1.23 0-1.938-1.4-1.208-2.39L17.989 1.043z"
});

var SvgNowBolt = function SvgNowBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "b991db01d1c698de7994ddcfab995fb2.svg";
export { SvgNowBolt as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/now-bolt.svg
// module id = null
// module chunks = 